import { Card } from '../Card'
import Styles from './ReviewRequestCard.module.scss'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { RequestCard } from 'components/ReviewSummaryModal/RequestCard'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { Button } from 'blaze-ui/Button'
import dayjs from 'dayjs'
import { Header } from './Header'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { displayDateFrom } from 'utils/dates'
import { Content } from './Content'
import { Text } from 'blaze-ui/Text/Text'
import { ReviewSubmissionDrawer } from 'components/DocRightPanelWrapper/Panels/ReviewSubmissionPanel/ReviewSubmissionDrawer'
import useResponsiveFunction from 'hooks/useResponsiveFunction'
import cx from 'classnames'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

interface Props {
  request: InformalFeedbackRequest
  reRequestMessage?: string | null
  isPostableOrDesign: boolean
}

export const ReviewerPendingCard = observer(({ request, reRequestMessage, isPostableOrDesign }: Props) => {
  const { isMobile } = useResponsiveDesign()

  if (!request) return null

  const message = reRequestMessage || request.html_description || request.description
  const creationDate = dayjs(request.created_at).format('MMM D, YYYY')
  const { rightRailPanelStore, drawersStore, designStore } = useRootStore()
  const reviewDesignLater = designStore?.file && isMobile && designStore?.reviewLater

  const openReviewSubmissionPanel = useResponsiveFunction({
    mobileFunction: () => drawersStore.openDrawer(ReviewSubmissionDrawer, { request }),
    defaultFunction: () => rightRailPanelStore.show('review_submission'),
  })

  const handleReviewLater = () => {
    designStore?.toggleReviewLater(true)
  }

  if (reviewDesignLater) return null

  return (
    <Card className={cx(Styles.reviewRequestCard, { [Styles.isPostableOrDesign]: isPostableOrDesign })}>
      <Header
        status={`Due ${displayDateFrom(request.ends_on)}`}
        onPress={request.design ? handleReviewLater : undefined}
      />
      <Content request={request}>
        <div className={cx(Styles.titleContainer, Styles.requester)}>
          <Text variant="largeList" color="var(--dark-80)">
            {request.requester.display_name} asked you to review this file {reRequestMessage ? ' again' : ''}
          </Text>
          {(!isPostableOrDesign || !isMobile) && <span className={Styles.creationDate}>{creationDate}</span>}
        </div>
        {!!message && (
          <RequestCard.Message>
            <ProseDisplay html={message} />
          </RequestCard.Message>
        )}
      </Content>
      <Button size={isMobile ? 'lg' : 'md'} onPress={openReviewSubmissionPanel}>
        Finish Your Review
      </Button>
    </Card>
  )
})
